// extracted by mini-css-extract-plugin
export default {"mCard":"Ux-z","image":"Vx-z","imageNoBackground":"Wx-z","fullWidth":"Xx-z"};